import RewardsStorefrontValuesService from "@apps/rewards/modules/StorefrontValues/service/RewardsStorefrontValuesService";
import { Observable, map, of } from "rxjs";
import { singleton } from "tsyringe";

@singleton()
class RewardsAmountFormatter {
    constructor(
        private readonly rewardsStorefrontValuesService: RewardsStorefrontValuesService
    ) {}

    public format(value: number): Observable<number> {
        if (Number.isInteger(value)) return of(value);

        return this.rewardsStorefrontValuesService
            .selectRewardsGeneralSettings()
            .pipe(
                map(({ pointsDecimalPlaces }) => {
                    const [integer, decimal] = value.toString().split(".");
                    const slicedDecimal = decimal.slice(0, pointsDecimalPlaces);

                    return parseFloat(`${integer}.${slicedDecimal}`);
                })
            );
    }
}

export default RewardsAmountFormatter;
